export class RegistrationAccordion {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      const animation = (content, flg) => {
        if (content === undefined) return

        const prev = content.previousElementSibling
        let contentHeight

        const tags = content.querySelector('.c-session_tab_trgs')
        if (tags) {
          const elms = content.querySelectorAll('.c-session_area.is-show')
          const tagsHeight = tags.clientHeight
          let areaHeight = 200
          elms.forEach((elm) => {
            areaHeight += elm.scrollHeight
          })
          contentHeight = areaHeight + tagsHeight
        } else {
          contentHeight = content.scrollHeight
        }

        const targetOffsetTop = window.pageYOffset + prev.getBoundingClientRect().top
        content.classList.add('is-show')

        if (flg) {
          content.style.height = contentHeight + 20 + 'px'
        } else {
          content.style.height = 'auto'
        }
        window.scrollTo({
          top: targetOffsetTop,
          behavior: 'smooth',
        })
      }

      const acoTrgs = document.querySelectorAll('.js-regi_trg')
      acoTrgs.forEach((data) => {
        data.addEventListener('click', (event) => {
          const id = event.currentTarget.getAttribute('data-target')
          const content = document.getElementById(id)
          sessionStorage.select !== '4' ? animation(content, true) : animation(content, false)
        })
      })

      const type = document.getElementById('js-select_type')
      const day1 = document.getElementById('js-day1')
      const day2 = document.getElementById('js-day2')
      const session = document.getElementById('js-session_area')
      const sessionArea = document.querySelectorAll('.c-session_area')

      const url = window.location.href
      const searchParams = new URL(url).searchParams
      const query = searchParams.get('SMPFORM')
      const targetValue = 'lcsj-ljnflb-66fcf66f35115ec7eebc4a09194cdf57'
      // "/en/"が含まれているかを確認
      if (query === targetValue) {
        session.classList.add('is-en')
      }

      const setDay1 = (content) => {
        day1.classList.add('is-act')
        day2.classList.remove('is-act')
        day1.classList.remove('is-disable')
        day2.classList.add('is-disable')
        session.classList.remove('is-hide')
        sessionArea[0].classList.add('is-show')
        sessionArea[1].classList.remove('is-show')
        animation(content, true)
      }

      const setDay2 = (content) => {
        day2.classList.add('is-act')
        day1.classList.remove('is-act')
        day2.classList.remove('is-disable')
        day1.classList.add('is-disable')
        session.classList.remove('is-hide')
        sessionArea[1].classList.add('is-show')
        sessionArea[0].classList.remove('is-show')
        animation(content, true)
      }
      const setDayAll = (content) => {
        day1.classList.remove('is-disable')
        day2.classList.remove('is-disable')
        sessionArea[1].classList.add('is-show')
        sessionArea[0].classList.add('is-show')
        session.classList.remove('is-hide')
        animation(content, true)
      }
      const setOnline = (content) => {
        session.classList.add('is-hide')
        animation(content, false)
      }

      const selectDate = sessionStorage.getItem('select')
      const target = document.getElementById('js-session')
      if (selectDate === '1') {
        setDay1()
      }
      if (selectDate === '2') {
        setDay2()
      }
      if (selectDate === '3') {
        setDayAll()
      }
      if (selectDate === '4') {
        setOnline(target)
        target.style.height = 0
      }

      type.addEventListener('change', (event) => {
        const val = event.currentTarget.value
        const content = document.getElementById('js-session')
        sessionStorage.select = val
        if (val === '1') {
          setDay1(content)
        }
        if (val === '2') {
          setDay2(content)
        }
        if (val === '3') {
          setDayAll(content)
        }
        if (val === '4') {
          setOnline(content)
        }
      })
    })
  }
}
